import React, { Component } from "react";
import { connect } from "react-redux";
import cookie from "react-cookie";
import { bindActionCreators } from "redux";
import { browserHistory } from "react-router";
import I18n from "lib/i18n/i18n";
import { createPendingJewelryBox } from "actions/pendingJewelryBox";
import PopupTypeQtySelector from "components/popups/popupTypeQtySelector";
import Tile from "./tile";
import { MediumPrimaryButton } from "@worthy-npm/clarity";
import { isMobile, rootUrl } from "helpers/ApplicationHelper";
import { ItemTypesPlural } from "../constants/itemDetails";

function setCreateSecondItemFlag(qty) {
    localStorage.setItem("createSecondItem", qty === 2);
}

class JewelryBoxForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submittedEmpty: false,
            gemsOrOtherErr: false,
            selectedTypes: [],
            itemTypes: {
                ring: {
                    name: "ring",
                    title: "RING(S)",
                    plural: "Rings",
                    selected: false,
                    noPhoto: false,
                    quantity: 0,
                    pluralBody: "rings/bridal sets",
                },
                diamond: {
                    name: "diamond",
                    title: "DIAMOND(S)",
                    plural: "Diamonds",
                    selected: false,
                    noPhoto: false,
                    quantity: 0,
                },
                earring: {
                    name: "earring",
                    title: "EARRINGS",
                    plural: "Earrings",
                    selected: false,
                    noPhoto: false,
                    quantity: 0,
                    pluralBody: "pairs of earrings",
                },
                necklace: {
                    name: "necklace",
                    title: "NECKLACE(S)",
                    plural: "Necklaces",
                    selected: false,
                    noPhoto: false,
                    quantity: 0,
                },
                bracelet: {
                    name: "bracelet",
                    title: "BRACELET(S)",
                    plural: "Bracelets",
                    selected: false,
                    noPhoto: false,
                    quantity: 0,
                },
                watch: {
                    name: "watch",
                    title: "WATCH(ES)",
                    plural: "Watches",
                    selected: false,
                    noPhoto: false,
                    quantity: 0,
                },
                gem: {
                    name: "gem",
                    title: "GEM(S)",
                    plural: "Gem",
                    selected: false,
                    noPhoto: false,
                    quantity: 0,
                },
                gold: {
                    name: "gold",
                    title: "GOLD",
                    plural: "Gold Jewelry",
                    selected: false,
                    noPhoto: false,
                    quantity: 0,
                },
                other: {
                    name: "other",
                    title: "OTHER",
                    plural: "Other Jewelry",
                    selected: false,
                    noPhoto: true,
                    quantity: 0,
                },
            },
        };

        this.submit = this.submit.bind(this);
        this.handlePendingJewelryBox = this.handlePendingJewelryBox.bind(this);
    }

    render() {
        let error = this.state.gemsOrOtherErr ? (
            <p className="submit-error">
                {" "}
                {I18n.getString("submitJBForm::gemsOrOtherErr")}
            </p>
        ) : (
            ""
        );
        let h1 = I18n.getString("submitJBForm::title");

        return (
            <div id="submit-jb-form">
                {this.props.submissionOnHomePage ? null : <h1>{h1}</h1>}
                <h3
                    className={
                        this.state.submittedEmpty ? "submitted-empty" : ""
                    }
                >
                    {I18n.getString("submitJBForm::subtitle")}
                </h3>
                {error}
                <div
                    className={
                        "panel-container" +
                        (this.state.submittedEmpty || this.state.gemsOrOtherErr
                            ? " error"
                            : "")
                    }
                >
                    {Object.keys(this.state.itemTypes).map((typeName) => {
                        return (
                            <Tile
                                type={this.state.itemTypes[typeName]}
                                key={typeName}
                                click={this.handleTileClick}
                            />
                        );
                    })}
                </div>
                <div className="submit-clarity-button-wrapper">
                    <MediumPrimaryButton
                        click={(stopAnimation) => {
                            stopAnimation();
                            this.submit();
                        }}
                        text={I18n.getString("submitJBForm::submitButton")}
                        disabled={this.state.gemsOrOtherErr}
                        overrideWrapperCSS={{
                            width: "100%",
                            textAlign: "center",
                        }}
                        overrideCSS={{
                            backgroundColor: "#2D5DEC",
                            borderRadius: "3px",
                            width: `${isMobile() ? "100%" : "125px"}`,
                            padding: "11px 22px 12px",
                            font: "500 16px Roboto",
                            marginTop: `${isMobile() ? "30px" : "60px"}`,
                        }}
                    />
                </div>
            </div>
        );
    }

    handleTileClick = (type, typeIndex) => {
        type.selected = !type.selected;
        type.quantity = type.quantity === 0 ? 1 : 0;
        let newState = {
            submittedEmpty: false,
            gemsOrOtherErr: false,
            itemTypes: Object.assign({}, this.state.itemTypes),
        };
        newState.itemTypes[typeIndex] = type;
        this.setState(newState);
    };

    componentDidMount() {}

    handlePendingJewelryBox() {
        const selectedSubsets = this.chooseSelectedTypes();
        this.props.createPendingJewelryBox(
            selectedSubsets.map((subset) => ({
                name: subset.name,
                quantity: subset.quantity,
            })),
            this.props.Session.isLoggedIn
        );

        if (!this.props.Session || !this.props.Session.isLoggedIn) {
            browserHistory.push("/register");
        }
    }

    quantityChangeApproved = (typeName, itemsQty) => {
        let newState = { itemTypes: Object.assign({}, this.state.itemTypes) };
        newState.itemTypes[typeName].quantity = itemsQty;
        this.setState({ newState });

        if (
            [
                "diamond",
                "bracelet",
                "watch",
                "necklace",
                "ring",
                "earring",
            ].includes(typeName)
        ) {
            if (itemsQty <= 2) {
                const query = itemsQty > 1 ? "alertMostValuable=true" : "";

                switch (typeName) {
                    case "diamond":
                        setCreateSecondItemFlag(itemsQty);
                        return browserHistory.push(`?${query}#Loose_Diamonds`);
                    case "earring":
                        if (itemsQty === 1) {
                            // Cookie for returning user back to the original form in monolith
                            cookie.save(
                                "seller_relative_path",
                                ItemTypesPlural["Earrings"],
                                {
                                    path: "/",
                                    expires: new Date(
                                        new Date().setYear(
                                            new Date().getFullYear() + 10
                                        )
                                    ),
                                    domain: ".worthy.com",
                                }
                            );
                            const target_url =
                                rootUrl("/form/#itemCategories/" +
                                    ItemTypesPlural["Earrings"]) ;
                            return (window.location = target_url);
                        } else this.handlePendingJewelryBox();
                        break;
                    default:
                        setCreateSecondItemFlag(itemsQty);
                        return browserHistory.push(
                            `/submit/${typeName}?${query}`
                        );
                }
            }
        }
        this.handlePendingJewelryBox();
    };

    chooseSelectedTypes = () => {
        return Object.values(this.state.itemTypes).filter((type) => {
            return type.selected;
        });
    };

    submit(e) {
        const selectedTypes = this.chooseSelectedTypes();

        if (selectedTypes.length === 0) {
            this.setState({ submittedEmpty: true });
            return;
        }

        if (selectedTypes.length === 1) {
            const selectedType = selectedTypes[0];

            switch (selectedType.name) {
                case "gem":
                case "other":
                    this.setState({ gemsOrOtherErr: true });
                    break;
                default:
                    PopupTypeQtySelector.initPopup({
                        single: true,
                        modal: true,
                        plural: selectedType.plural,
                        pluralBody: selectedType.pluralBody,
                        name: selectedType.name,
                        quantity: selectedType.quantity,
                        quantityChangeApproved: this.quantityChangeApproved,
                    });
            }
        }

        if (selectedTypes.length > 1) {
            this.handlePendingJewelryBox();
        }
    }
}

const mapStateToProps = ({ Session }) => {
    return { Session };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ createPendingJewelryBox }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(JewelryBoxForm);
